module.exports = __webpack_public_path__ + "static/img/icon4-12.3b4692ad.png";